import { useEffect, useRef } from "react";
import { Badge } from "../../components/ui";
import { MdDelete, MdForum } from "react-icons/md";
import { DocTypeBadge } from "../../shared/docTypes";
import { formatDateFr } from "../../shared/dateFormat";
import { HabBadge, habColor } from "../../shared/habilitations";
import { statutColor, verifColor } from "../../shared/statusColors";
import { COLORS, RADIUS } from "../../shared/theme";

export default function ProofCard({ proof, onEdit, onDelete, personnes, highlightId = null, highlightItemType = null }) {
  const sc = statutColor[proof.statut] || statutColor["En cours"];
  const vc = verifColor[proof.statutVerif] || verifColor["À vérifier"];
  const resp = personnes.find(p => p.id === proof.responsableId || p.id === Number(proof.responsableId));
  const hc = resp ? (habColor[resp.habilitation] || habColor["Autre"]) : null;
  const hid = highlightId != null ? Number(highlightId) : null;
  const typeOk = !highlightItemType || highlightItemType === "preuve";
  const isHighlighted = typeOk && (proof.id === hid || Number(proof.id) === hid);
  const cardRef = useRef(null);

  useEffect(() => {
    if (isHighlighted && cardRef.current) {
      cardRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }, [isHighlighted, hid]);

  return (
    <div
      ref={cardRef}
      style={{
        background: COLORS.white,
        borderRadius: RADIUS.lg,
        border: `1.5px solid ${isHighlighted ? "#f59e0b" : COLORS.border}`,
        padding: 18,
        marginBottom: 12,
        boxShadow: isHighlighted ? "0 0 0 2px #fef3c7" : "0 1px 4px rgba(0,0,0,0.04)",
        transition: "box-shadow 0.2s",
      }}
      onMouseEnter={e => !isHighlighted && (e.currentTarget.style.boxShadow = "0 4px 16px rgba(37,99,235,0.09)")}
      onMouseLeave={e => !isHighlighted && (e.currentTarget.style.boxShadow = "0 1px 4px rgba(0,0,0,0.04)")}
    >
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 10 }}>
        <div style={{ flex: 1 }}>
          <div style={{ fontWeight: 700, fontSize: 14, color: COLORS.textPrimary, marginBottom: 6 }}>{proof.intitule}</div>
          <div style={{ display: "flex", gap: 6, flexWrap: "wrap", alignItems: "center" }}>
            {proof.docType && <DocTypeBadge code={proof.docType} />}
            <Badge label={proof.statut} colors={sc} />
            <Badge label={proof.statutVerif} colors={vc} />
          </div>
        </div>
        <div style={{ display: "flex", gap: 6, flexShrink: 0, marginLeft: 12 }}>
          <button onClick={() => onEdit(proof)} style={{ padding: "4px 10px", borderRadius: RADIUS.sm, border: `1.5px solid ${COLORS.primaryAccent}`, background: "transparent", color: COLORS.primaryAccent, fontSize: 12, fontWeight: 600, cursor: "pointer" }}>Éditer</button>
          <button onClick={() => onDelete(proof.id)} style={{ padding: "4px 10px", borderRadius: RADIUS.sm, border: "1.5px solid #fee2e2", background: "#fff5f5", color: "#dc2626", fontSize: 12, fontWeight: 600, cursor: "pointer", display: "inline-flex", alignItems: "center" }}><MdDelete size={14} /></button>
        </div>
      </div>
      <div style={{ fontSize: 12, color: COLORS.textSecondary, marginBottom: 10 }}>{proof.description}</div>
      <div style={{ display: "flex", gap: 16, flexWrap: "wrap", fontSize: 11, color: "#374151", alignItems: "center" }}>
        {resp && hc && (
          <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
            <div style={{ width: 24, height: 24, borderRadius: "50%", background: hc.bg, border: `1.5px solid ${hc.border}`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 10, fontWeight: 800, color: hc.text, flexShrink: 0 }}>
              {resp.prenom[0]}{resp.nom[0]}
            </div>
            <span>{resp.prenom} {resp.nom}</span>
            <HabBadge habilitation={resp.habilitation} />
          </div>
        )}
        <div><span style={{ color: COLORS.textMuted }}>Version : </span>{proof.version}</div>
        {proof.derniereMaj && <div><span style={{ color: COLORS.textMuted }}>Maj : </span>{formatDateFr(proof.derniereMaj)}</div>}
        {proof.registre && <div><span style={{ color: COLORS.textMuted }}>Registre : </span>{proof.registre}</div>}
      </div>
      {proof.commentaires && (
        <div style={{ marginTop: 10, padding: "7px 12px", background: "#fef9c3", borderRadius: RADIUS.sm, fontSize: 11, color: "#78350f" }}>
          <span style={{ display: "inline-flex", alignItems: "center", gap: 4 }}><MdForum size={13} /> {proof.commentaires}</span>
        </div>
      )}
    </div>
  );
}
